import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { Avatar, UserAvatar } from '../../common/Avatar'
import { NotificationData } from '../../../types/notifications'
import { societyQueries } from '../../../api/societies'
import { userQueries } from '../../../api/users'
import { INotificationModel } from '../../../interfaces/models/notifications.interfaces'

interface NotificationAvatarProps {
  notification: INotificationModel
  notificationData: NotificationData | undefined
}

export const NotificationAvatar = ({
  notification,
  notificationData,
}: NotificationAvatarProps): React.ReactNode => {
  const notificationFromUser = notificationData && notificationData.from
  const notificationSociety = notificationData && notificationData.society
  const notificationRoom = notificationData && notificationData.room

  const { data: society } = useQuery(
    societyQueries.getSociety(notificationRoom?.societyId)
  )
  const { data: _society } = useQuery(
    societyQueries.getSociety(notification?.societyId)
  )
  const { data: user } = useQuery(
    userQueries.getUser(notificationFromUser?._id)
  )

  let url

  if (notificationSociety) {
    url = notificationSociety.coverPhoto?.url
  } else if (notificationRoom) {
    url = society?.coverPhoto?.url
  } else if (notification.societyId) {
    url = _society?.coverPhoto?.url
  }

  if (
    notification.type === 'invite-all-to-society' &&
    notificationSociety?.coverPhoto
  ) {
    return <Avatar url={notificationSociety.coverPhoto.url} />
  }
  if (
    notification.type === 'new-ticket-from-board' &&
    notificationSociety?.coverPhoto
  ) {
    return <Avatar url={notificationSociety.coverPhoto.url} />
  }

  return notificationFromUser ? (
    <UserAvatar user={user} />
  ) : (
    <Avatar url={url} />
  )
}
